import { useAuth } from "@/lib/AuthContext";
import { UserCircle } from "@phosphor-icons/react";

export default function ProfilePage({ currentUser }) {
  const { logout } = useAuth();

  if (!currentUser) return null;

  return (
    <div className="h-full overflow-y-auto" data-testid="profile-page">
      <div className="max-w-2xl mx-auto p-6 lg:p-8 space-y-6">
        <h1 className="text-3xl font-black tracking-tight font-heading text-slate-900">Profile</h1>
        <div className="bg-white border border-slate-200 rounded-md p-6">
          <div className="flex items-center gap-4 mb-6">
            <div className="w-16 h-16 bg-black/10 rounded-full flex items-center justify-center">
              <UserCircle weight="duotone" className="w-10 h-10 text-foreground" />
            </div>
            <div>
              <h2 className="text-xl font-bold font-heading text-slate-900">{currentUser.full_name}</h2>
              <p className="text-sm text-slate-500">{currentUser.email}</p>
              <span className="text-[10px] font-bold uppercase px-2 py-0.5 rounded bg-slate-100 text-slate-600 mt-1 inline-block">{currentUser.role}</span>
            </div>
          </div>
          <div className="space-y-3 text-sm border-t border-slate-100 pt-4">
            {currentUser.branch && <div><span className="text-slate-500 font-semibold">Branch:</span> <span className="text-slate-700">{currentUser.branch}</span></div>}
            <div><span className="text-slate-500 font-semibold">Role:</span> <span className="text-slate-700">{currentUser.role}</span></div>
          </div>
        </div>
        <button data-testid="profile-logout" onClick={logout}
          className="h-11 px-6 bg-red-50 border border-red-200 text-red-600 rounded-md text-sm font-bold hover:bg-red-100 transition-colors">
          Sign Out
        </button>
      </div>
    </div>
  );
}
